/* eslint-disable linebreak-style */
/* eslint-disable camelcase */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import NavLink from 'components/NavLink';
import Icon from 'base-ui/dist/Icon';
import Modal from 'base-ui/dist/Modal';
import Container from 'base-ui/dist/Container';
import { intl } from 'components/LocaleProvider';
import DateFormat from 'components/DateFormat';
import messages from './messages';

const getConfig = require('next/config').default;

const { publicRuntimeConfig = {} } = getConfig ? getConfig() : {};

const PostMetas = ({ post, dateIcon }) => {
  const [modalIsOpen, setIsOpen] = useState(false);
  const [modalConfig, setModalConfig] = useState(false);

  function openModal(text, height, e) {
    setModalConfig({ text, height });
    setIsOpen(true);
    e.preventDefault();
  }

  return (
    <React.Fragment>
      <div className="pre-meta">
        {post.options?.is_sponsored && (
          <a
            href="#"
            onClick={(e) => openModal(
              intl.formatMessage(messages.modalSponsored, {
                pageName: publicRuntimeConfig.blogname,
                pageSponsor: post.options.sponsor || intl.formatMessage(messages.ourPartners)
              }),
              '170px',
              e
            )}
            className="btn grey-border grey-bg rounded small regent-grey-color"
            data-with-google-events="true"
            data-google-events={JSON.stringify({
              data: {
                action: 'click',
                category: 'Post',
                label: 'Sponsored'
              }
            })}
          >
            {intl.formatMessage(messages.sponsored)}
          </a>
        )}

        {post.options?.verification_status === 'fact_checked' && (
          <a
            href="#"
            onClick={(e) => openModal(
              intl.formatMessage(messages.modalFact, {
                contactLink: `<strong><a target="_blank" rel="noopener noreferrer" href="mailto:info@mcontigo.com">${intl.formatMessage(messages.contactUs)}</a></strong>`
              }),
              '270px',
              e
            )}
            className="btn aqua-border aqua-bg rounded small white-color btn-fact"
            data-with-google-events="true"
            data-google-events={JSON.stringify({
              data: {
                action: 'click',
                category: 'Post',
                label: 'Fact Checked'
              }
            })}
          >
            <Icon prefix="fas" name="check" />
            {` ${intl.formatMessage(messages.factChecked)}`}
          </a>
        )}

        {post.options?.verification_status === 'evidence_based' && (
          <a
            href="#"
            onClick={(e) => openModal(
              intl.formatMessage(messages.modalEvidence, {
                contactLink: `<strong><a target="_blank" rel="noopener noreferrer" href="mailto:info@mcontigo.com">${intl.formatMessage(messages.contactUs)}</a></strong>`
              }),
              '220px',
              e
            )}
            className="btn green-border green-bg rounded small white-color btn-fact"
            data-with-google-events="true"
            data-google-events={JSON.stringify({
              data: {
                action: 'click',
                category: 'Post',
                label: 'Evidence Based'
              }
            })}
          >
            <Icon prefix="fas" name="check-double" />
            {` ${intl.formatMessage(messages.evidenceBased)}`}
          </a>
        )}
      </div>
      <div className="metas">
        {post?.options?.author === 'on' && post?.author?.type === 'author' && (
          <span className="meta author">
            <NavLink
              basePath={publicRuntimeConfig.PUBLIC_URL}
              to={`/author?slug=${post.author.slug}`}
              as={`${post?.author?.permalink}`}
              routerStrategy={'next'}
              className="highlight utilitary-border"
            >
              {post.author.name}
            </NavLink>
          </span>
        )}

        {post?.options?.author === 'on' && post?.author?.type === 'author' && post.options.date === 'on' && (
          <span className="meta spacer">·</span>
        )}

        {post.options.date === 'on' && (
          <span className="meta date">
            {post.published >= post.modified ? (
              <>
                <Icon prefix="far" name="calendar" />
                {' '}
                <DateFormat>{post.published}</DateFormat>
              </>
            ) : (
              <>
                <Icon prefix="far" name={dateIcon} />
                {' '}
                <DateFormat>{post.modified}</DateFormat>
              </>
            )}
          </span>
        )}
      </div>

      {modalIsOpen && (
        <Modal
          isOpen={modalIsOpen}
          closeModal={() => setIsOpen(false)}
          shouldCloseOnOverlayClick
          appElement="#__next"
          closeIcon
          width="550px"
          height={modalConfig.height}
        >
          <Container fluid wrap>
            <p
              dangerouslySetInnerHTML={{
                __html: modalConfig.text
              }}
            />
          </Container>
        </Modal>
      )}
    </React.Fragment>
  );
};

PostMetas.defaultProps = {
  post: {},
  dateIcon: 'clock'
};

PostMetas.propTypes = {
  post: PropTypes.object,
  dateIcon: PropTypes.string
};

export default PostMetas;
